export default "__VITE_ASSET__BEjIjbLp__"